<template>
  <div id="app">
    <Landing/>
  </div>
</template>

<script>
  import Landing from './components/Landing.vue'
  import GetId from './modules/mixins/GetId';

  export default {
    name: 'app',
    components: {
      Landing,
    },
    mixins: [
      GetId,
    ],
    data() {
      return {}
    },
    created() {},
    mounted() {
      fetch(new Request(
          `${this.$mainUrl}api/funnel_01/010/${this.getId()}`,
          {
            method: 'GET',
            mode: 'no-cors',
          })
      );
    }
  }
</script>

<style lang="scss">
  @import "./../static/scss/main";

  html {
    scroll-behavior: smooth;
  }

  #app {
    @include site-font(default, null, 500);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    overflow: hidden;
  }

  body {
    margin: 0;
    background: #323145;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  *::-webkit-scrollbar {
    width: 7px;
    background: none;
  }

  *::-webkit-scrollbar-track-piece:disabled {
    display: none !important;
  }

  *::-webkit-scrollbar-track {
    background: #1b1a2580;
  }

  *::-webkit-scrollbar-track:hover {
    background: #1b1a25;
  }

  *::-webkit-scrollbar-thumb {
    background: rgba(#6f6d99, .5);
  }

  *::-webkit-scrollbar-thumb:hover {
    background: #6f6d99;
  }

  *:focus,
  *:active,
  button:focus,
  button:active,
  input:focus,
  input:active,
  textarea:focus,
  textarea:active,
  a:focus,
  a:active,
  button,
  a,
  input,
  label {
    outline: none !important;
    outline-offset: 0 !important;
    text-decoration: none;
  }

  .hidden-tablet-portrait-up {
    @include for-tablet-portrait-up {
      display: none;
    }
  }

  .hidden-phone-landscape {
    @media screen AND (max-width: 767px) {
      display: none;
    }
  }

  .btn.focus, .btn:focus {
    outline: 0;
    box-shadow: none;
  }

  .btn-style_primary {
    background-image: linear-gradient(90deg, #f52bc0, #ff7c45);
  }

  .btn-style_primary-two {
    background-image: linear-gradient(90deg, #6808c2, #f52bc0);
  }

  .btn-style_secondary {
    background-image: linear-gradient(90deg, #5d588a, #8e87c4);
  }

  .router-link-exact-active .btn-style_primary .btn:before,
  .btn-custom-block.btn-style_primary .btn:active:before {
    background: linear-gradient(
        90deg,
        rgba(#f52bc0, .25) 0%,
        rgba(#ffffff, 0) 25%,
        rgba(#ffffff, 0) 75%,
        rgba(#ff7c45, .25) 100%
    );
  }

  .router-link-exact-active .btn-style_primary-two .btn:before,
  .btn-custom-block.btn-style_primary-two .btn:active:before {
    background: linear-gradient(
        90deg,
        rgba(#6808c2, .25) 0%,
        rgba(#ffffff, 0) 25%,
        rgba(#ffffff, 0) 75%,
        rgba(#f52bc0, .25) 100%
    );
  }

  .btn-custom-block.btn-style_secondary .btn:active:before {
    background: linear-gradient(
        90deg,
        rgba(#5d588a, .25) 0%,
        rgba(#ffffff, 0) 25%,
        rgba(#ffffff, 0) 75%,
        rgba(#8e87c4, .25) 100%
    );
  }

  .btn-custom-block.btn-style_primary .btn:active,
  .btn-custom-block.btn-style_primary-two .btn:active,
  .btn-custom-block.btn-style_secondary .btn:active {
    background-image: -webkit-gradient(linear, left top, right top, from(#302f43), to(#43425d));
    background-image: linear-gradient(90deg, #302f43, #43425d);
  }

  .nav-item .btn-style_primary-two .btn,
  .nav-item .btn-style_primary .btn,
  .btn-custom-block .btn,
  .btn-style_primary-two .btn,
  .btn-style_secondary .btn {
    background-image: linear-gradient(90deg, #242333, #3c3b53);
  }

  .router-link-exact-active .btn-style_primary-two .btn:hover,
  .router-link-exact-active .btn-style_primary .btn:hover,
  .btn-custom-block .btn:hover,
  .btn-style_primary-two .btn:hover,
  .btn-style_secondary .btn:hover {
    background-image: linear-gradient(90deg, #242333, #6f6d99);
  }

  .btn-custom-block .btn:focus {
    outline: none !important;
    box-shadow: none;
  }

  .btn-custom-block .btn {
    padding: 9px 50px;
    min-width: 195px;
    color: #fff;
    margin: 0;
    border: 2px solid #242333;
    border-radius: 50px;
    letter-spacing: 1px;
    position: relative;
    overflow: hidden;
    font-family: "Roboto", "Arial", sans-serif;
    font-size: inherit;
    font-weight: 500;
  }

  .btn-custom-block,
  .btn-filter,
  .btn-search {
    display: inline-block;
    padding: 2px;
    max-height: 50px;
    border-radius: 30px;
    box-shadow: 0 7px 21px #090a0f26;
    align-items: center;
  }
</style>
